var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Router } from '@vaadin/router';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref, createRef } from 'lit/directives/ref.js';
import { routes } from './b2b-router.js';
import { loadFooter } from './initialization/footerLoader.js';
import '../src/elements/b2b/b2b-element-header.js';
import { normalizeB2bUrl } from './urlHandling/urlNormalizer.js';
import { resolveDeployPrefix } from './initialization/deployPrefixResolver.js';
import { defaultB2bLanguage } from './unspecific/languageUtils.js';
import './elements/element-big-gallery.js';
import { initializeAnalytics } from './analytics.js';
import { isB2bPage$ } from './stores/store-b2b.js';
import { initializeViewHeight } from './vhHack.js';
main();
async function main() {
    initializeAnalytics();
    const deployPrefix = resolveDeployPrefix();
    const initialURL = document.location.toString();
    const normalizedURL = normalizeB2bUrl(initialURL, deployPrefix, defaultB2bLanguage);
    if (normalizedURL && normalizedURL !== initialURL) {
        window.history.replaceState(null, undefined, normalizedURL);
    }
    initializeViewHeight();
}
let B2BIndex = class B2BIndex extends LitElement {
    constructor() {
        super(...arguments);
        this.outletRef = createRef();
    }
    render() {
        return html `
      <b2b-element-header></b2b-element-header>
      <div
        id="main"
        class="overflow-overlay h-screen-wo-header-b2b overflow-x-hidden"
      >
        <div ${ref(this.outletRef)}></div>
        <element-footer .b2bPage=${true}></element-footer>
      </div>
      <element-big-gallery></element-big-gallery>
    `;
    }
    async firstUpdated() {
        const router = new Router();
        router.setOutlet(this.outletRef.value);
        loadFooter(this.outletRef.value);
        router.setRoutes(routes);
        isB2bPage$.next(true);
    }
    createRenderRoot() {
        return this;
    }
};
B2BIndex = __decorate([
    customElement('b2b-index')
], B2BIndex);
//# sourceMappingURL=b2b-index.js.map